import { Banner } from "../../components/Banner/Banner";
import { Categories } from "../../components/Categories/Categories";
import { Footer } from "../../components/Footer/Footer";

export const Home = () => {
  return (
    <div>
      <Banner />
      <Categories />
      <Footer/>
    </div>
  );
};
